import { Component } from 'react';
import { createBrowserHistory } from 'history';

export const historySim = createBrowserHistory();

interface IArgs {
    container: Element;
    content: JSX.Element;
}
interface IRouteStack {
    content: JSX.Element;
    name?: string;
    position?: {
        top?: number;
        left?: number;
    };
    snapshots?: ChildNode[];
    data?: any;
}

export class UmuHistory extends Component {
    public container: Element;
    public content: JSX.Element;
    public stack: IRouteStack[] = [];
    public index = 0;
    constructor(props: IArgs) {
        super(props);
        this.container = props.container;
        this.content = props.content;
    }

    public init() {
        this.stack.push({
            name: '/',
            content: this.content,
        });
    }

    public push(name: string, data: IRouteStack) {
        const active = this.stack[this.index];
        active.snapshots = Array.from(this.container.childNodes);
        this.stack.push(Object.assign(data, {name}));
    }
    public replace(name: string, data: IRouteStack) {
        this.stack.pop();
        this.push(name, data);
    }
    public back() {
        if (this.index) {
            this.index -= 1;
        }
        this.render();
    }
    public render() {
        const active = this.stack[this.index];
        if (!active) {
            return;
        }
        this.container.innerHTML = '';
        active.snapshots!.forEach((snapshot: ChildNode | Node) => {
            this.container.appendChild(snapshot as Node);
        });
        return null;
    }
}
